import noop from "lodash/noop";

export default function onUserInteractionInitiatedPlaybackPropType(
  props,
  propName,
  componentName,
) {
  const propValue = props[propName];

  if (props.waitingForInitialPlay) {
    if (!propValue || propValue === noop) {
      return new Error(
        `Required prop \`${propName}\` was not specified in \`${componentName}\` It is required when \`props.waitingForInitialPlay\` is \`true\`.`,
      );
    }
    if (typeof props[propName] !== "function") {
      return new Error(
        `Prop ${propName} in ${componentName} needs to be a function.`,
      );
    }
  }

  return null;
}
